import { render, staticRenderFns } from "./ListCoupons.vue?vue&type=template&id=24052774&scoped=true&"
import script from "./ListCoupons.vue?vue&type=script&lang=js&"
export * from "./ListCoupons.vue?vue&type=script&lang=js&"
import style0 from "./ListCoupons.vue?vue&type=style&index=0&id=24052774&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24052774",
  null
  
)

export default component.exports